import { useLoginController } from "./controller";
import LOGO from "../../assets/images/ant-logo-final.jpeg";
import { Box, Grid, IconButton, Stack, Typography } from "@mui/material";
import ErrorMessageComponent from "../../components/errorMessage";
import { LoadingButton } from '@mui/lab';
import useScreen from "../../hooks/useScreen";
import { useTranslation } from 'react-i18next';
import LanguagePopover from "../../components/LanguagePopover";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import LOGO_V3 from '../../assets/images/logo_v3.svg';
import { SECONDARY_COLOR } from "../../constants/colors";
import RegisterMerchantForm from "./page/registerForm";

export default function LoginView() {
    const controller = useLoginController();
    const { isMobileScreen } = useScreen();
    const { t } = useTranslation("global");

    return <>
        <Box>
            <Box pr={5} sx={{ height: 50, display: 'flex', alignItems: 'center' }}>
                <Stack
                    flexGrow={1}
                    direction="row"
                    alignItems="center"
                    justifyContent="flex-end"
                    spacing={{ xs: 0.5, sm: 1.5 }}

                >
                    <LanguagePopover />
                </Stack>
            </Box>
            {
                controller.openSignUpForm ? <RegisterMerchantForm onClose={controller.handleCloseRegisterMerchant} /> : <Box>
                    {
                        !controller.isForgotPasswordPage
                            ?
                            <Grid container spacing={2} sx={{ height: 'calc(100vh - 50px)', display: 'flex', alignItems: 'center' }}>
                                {
                                    !isMobileScreen
                                    &&
                                    <Grid item xs={12} sm={6}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <img src={LOGO} alt="Logo" style={{ width: '50%', objectFit: 'contain', borderRadius: "16px" }} />
                                        </Box>
                                    </Grid>
                                }
                                <Grid item xs={12} sm={6} >
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
                                        <Box sx={{
                                            backgroundColor: '#EBF9FF',
                                            borderRadius: '16px',
                                            p: "10%",
                                            width: '100%',
                                            maxWidth: 500
                                        }}>
                                            <h1 style={{ textAlign: "center" }}>{t('login_page.Welcome to Ant Ecommerce')}</h1>
                                            <form onSubmit={controller.onSubmit}>
                                                <Box>
                                                    <p>{t('Username')}</p>
                                                    <input type="text" ref={controller.username} required placeholder={t("Enter Username") || ''} style={{
                                                        width: "100%",
                                                        height: "50px",
                                                        borderRadius: "8px",
                                                        background: "var(--transparent-grey-8, rgba(145, 158, 171, 0.08))",
                                                        border: 'none',
                                                        padding: "0 10px 0 10px"
                                                    }} />
                                                </Box>
                                                <Box>
                                                    <p>{t('Password')}</p>
                                                    <input type="password" ref={controller.password} required placeholder={t('Enter Password') || ''} style={{
                                                        width: "100%",
                                                        height: "50px",
                                                        borderRadius: "8px",
                                                        background: "var(--transparent-grey-8, rgba(145, 158, 171, 0.08))",
                                                        border: 'none',
                                                        padding: "0 10px 0 10px"
                                                    }} />
                                                </Box>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <Typography onClick={controller.handleOpenIsForgotPasswordPage} sx={{ mt: 2, color: 'red', textDecoration: 'underline', cursor: 'pointer', textAlign: 'end' }}>{t("login_page.Forgot username or password?")}</Typography>
                                                    {/* <Typography onClick={controller.handleOpenRegisterMerchant} sx={{ mt: 2, color: 'red', textDecoration: 'underline', cursor: 'pointer', textAlign: 'end' }}>Register Merchant</Typography> */}
                                                </Box>
                                                <ErrorMessageComponent errorMessage={controller.errorMessage} />
                                                <Box mt={2} display="flex" justifyContent="center">
                                                    <LoadingButton loading={controller.loggingIn} type="submit" variant="contained" sx={{ backgroundColor: SECONDARY_COLOR, textTransform: 'none', minWidth: 100 }}>{t("Login")}</LoadingButton>
                                                </Box>
                                            </form>
                                        </Box>
                                    </Box>

                                </Grid>
                            </Grid>
                            :
                            <Box sx={{ paddingLeft: '10%', paddingRight: '10%' }}>
                                <Box sx={{ height: '50px', display: 'flex', alignItems: 'center' }}>
                                    <IconButton onClick={controller.handleCloseIsForgotPasswordPage} sx={{ mb: 2 }}>
                                        <KeyboardBackspaceIcon />
                                    </IconButton>
                                </Box>

                                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: 'calc(100vh - 100px)', gap: 2 }}>
                                    <img alt="" src={LOGO_V3} style={{ width: '100%', maxWidth: '467px', height: 'auto' }} />
                                    <Typography sx={{ fontSize: '36px', color: '#8D8D8D' }}>{t("login_page.Contact support")} 020 28445777</Typography>
                                </Box>
                            </Box>
                    }
                </Box>
            }


        </Box>



    </>
}